// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e122d870","455":"27c3f615","977":"d41f2b6b"}[chunkId] + ".chunk.js";
};